// Storefront product tile shared by Home, Shop, and the product page's
// "You may also like" row.
import { Link } from 'react-router-dom';

export default function ProductCard({ product, isHighlighted = false, highlightedRef = null }) {
  const soldOut = product.inStock === false;

  return (
    <Link
      ref={highlightedRef}
      to={`/product/${product.id}`}
      className={`group block ${isHighlighted ? 'ring-2 ring-gold-500 ring-offset-4 ring-offset-cream-100 rounded-xl' : ''}`}
    >
      <div className="aspect-square bg-cream-200 relative overflow-hidden rounded-xl">
        {product.photoUrl ? (
          <img
            src={product.photoUrl}
            alt={product.description || product.name}
            className={`w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 ${soldOut ? 'opacity-60' : ''}`}
            loading="lazy"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <img src="/logo.png" alt="" className="w-1/2 opacity-40" />
          </div>
        )}

        {isHighlighted && (
          <span className="absolute top-3 left-3 bg-gold-500 text-white px-3 py-1 rounded-full text-xs font-medium">
            Scanned
          </span>
        )}
        {soldOut && (
          <span className="absolute top-3 right-3 bg-ink/80 text-cream-50 px-3 py-1 rounded-full text-xs font-medium">
            Sold out
          </span>
        )}
      </div>

      <div className="pt-4 px-1">
        <p className="text-[11px] uppercase tracking-[0.18em] text-ink-muted mb-1">{product.name}</p>
        <h3 className="font-serif text-xl leading-snug text-ink capitalize line-clamp-2 group-hover:text-sage-700 transition-colors">
          {product.description || product.name}
        </h3>
        <p className="mt-1 font-medium text-sage-700">${product.price.toFixed(2)}</p>
      </div>
    </Link>
  );
}
